import cookies from 'js-cookie';

import { COOKIE_DOMAIN } from '../config';
import cookieNames from '../constants/cookieNames';

const knownLanguages = ['de', 'en', 'ja', 'es', 'fr', 'zh'];

const getLanguage = (mapLang) => {
  if (typeof window === 'undefined') return 'en';

  let pageLanguage = window.location.pathname.split('/')[1];

  if (pageLanguage === 'jp') {
    pageLanguage = 'ja';
  }

  if (pageLanguage && knownLanguages.indexOf(pageLanguage) !== -1) {
    return mapLang && mapLang[pageLanguage] !== undefined
      ? mapLang[pageLanguage]
      : pageLanguage;
  }

  const browserLanguage =
    window.navigator.language && window.navigator.language.slice(0, 2);

  if (browserLanguage && knownLanguages.indexOf(browserLanguage) !== -1) {
    return mapLang && mapLang[browserLanguage] !== undefined
      ? mapLang[browserLanguage]
      : browserLanguage;
  }

  return 'en';
};

const getCountry = () => {
  const cookieCountry = cookies.get(cookieNames.localizationCountry);

  return cookieCountry || 'US';
};

const getCookieDomainPermutaions = (domain) => [
  domain,
  `.${domain}`,
  `www.${domain}`,
  `.www.${domain}`,
];

const clearAndSetCookie = (cookieName, value) => {
  // We want to ensure, where we have control, that only one
  // instance of a cookie exists. on some envs like testing and staging,
  // we often have situations where a localization_country cookie can be set
  // on .native-instruments, .testing, .www.testing, www.testing, etc
  // which don't match the COOKIE_DOMAIN var.
  if (typeof window !== 'undefined') {
    try {
      const rootDomain = window.location.hostname.replace(
        /^(https?:\/\/)?(www.)?/,
        ''
      );

      // only do this on non-prod envs
      if (/^native-instruments\./.test(rootDomain)) return;

      const domains = getCookieDomainPermutaions(rootDomain).concat(
        getCookieDomainPermutaions('native-instruments.com')
      );

      domains.forEach((domain) => {
        cookies.remove(cookieName, { domain });
      });
    } catch (e) {
      // fail silently since this is not critical on prod
    }
  }

  cookies.set(cookieName, value, { domain: COOKIE_DOMAIN });
};

const setCountryCookie = (country) => {
  clearAndSetCookie(cookieNames.localizationCountry, country);
};

export { getLanguage, getCountry, setCountryCookie };
